import { render, staticRenderFns } from "./PlanSettingsPlatforms.vue?vue&type=template&id=11843c4d"
import script from "./PlanSettingsPlatforms.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsPlatforms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports